import { render, staticRenderFns } from "./Agree.vue?vue&type=template&id=4a377394&scoped=true&"
import script from "./Agree.vue?vue&type=script&lang=js&"
export * from "./Agree.vue?vue&type=script&lang=js&"
import style0 from "./Agree.vue?vue&type=style&index=0&id=4a377394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a377394",
  null
  
)

export default component.exports